import AppleIcon from '~/assets/icons/Apple';
import { Button } from '~/components/Button';
import Tracked from '~/components/Tracked';
import useDismissInteraction from '~/hooks/useDismissInteraction';
import useNavigationLinkImpression from '~/hooks/useNavigationLinkImpression';
import useNavigationLinkInteraction from '~/hooks/useNavigationLinkInteraction';
import useRegion from '~/hooks/useRegion';

import AnimatedFrame from './AnimatedFrame';

type Props = {
  onDismiss: () => void;
};

const DownloadAppBanner = ({ onDismiss }: Props) => {
  const appsFlyerLink = 'https://thesolesupplier.onelink.me/BPkz/ne7v82xd';
  const appLinkLabel = 'Download the app';

  const region = useRegion();
  const fireAppLink = useNavigationLinkInteraction('app_banner');
  const fireDismiss = useDismissInteraction('app_download');
  const impressionRef = useNavigationLinkImpression<HTMLDivElement>({
    href: appsFlyerLink,
    label: appLinkLabel,
    placement: 'app_banner',
    position: 1
  });

  function dismiss() {
    void fireDismiss();
    onDismiss();
  }

  if (region.code !== 'GB') return null;

  return (
    <AnimatedFrame>
      <div
        ref={impressionRef}
        className="content-width flex w-full flex-col items-center justify-between gap-2 py-4 md:flex-row"
      >
        <p className="w-full text-sm  font-normal tracking-normal lg:text-base">
          Tired of missing drops? Get instant release reminders.
        </p>
        <div className="flex w-full gap-2">
          <div className="w-1/3">
            <Button onClick={dismiss} variant="transparent-white-border">
              Dismiss
            </Button>
          </div>
          <div className="flex w-2/3 items-center justify-center rounded-md bg-white font-semibold text-black">
            <Tracked.ExternalLink
              name="DOWNLOAD_THE_APP"
              onClick={() =>
                fireAppLink(appsFlyerLink, 1, { label: appLinkLabel })
              }
              pagePosition="Banner"
              href={appsFlyerLink}
              target="_blank"
              rel="noreferrer"
              variant="white-borderless"
              className="flex size-full items-center justify-center gap-2"
            >
              <AppleIcon colour="black" />
              <span>{appLinkLabel}</span>
            </Tracked.ExternalLink>
          </div>
        </div>
      </div>
    </AnimatedFrame>
  );
};

export default DownloadAppBanner;
